import React from 'react';

function TootedIntro() {
  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 select-none">
            <h1 className="h1 mb-4 text-blue-200" data-aos="zoom-y-out">Täiendamisel...</h1>
          </div>

          {/* Image */}
          <div>
            <figure className="flex justify-center items-start" data-aos="zoom-y-out" data-aos-delay="450">
              <img className="rounded shadow-2xl" src={require('../images/tutorial-09.jpg').default} width="768" height="432" alt="Ettevõttest" />
            </figure>
          </div>

        </div >
      </div >
    </section >
  );
}

export default TootedIntro;
